import { AdMediaCarousel, AdMediaCarouselProps } from "./AdMediaCarousel"

export const AdMediaFooterCarousel = (props: AdMediaCarouselProps) => {
  return (
    <AdMediaCarousel
      {...props}
      componentName="VuiAdMediaCarouselFooter"
      width={1080}
      height={480}
      spacing={0}
    />
  )
}
